// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--3yuZa","headerContent":"header-module--headerContent--2E7vv","logo":"header-module--logo--1e507","logoText":"header-module--logoText--pH51c"};